import React from 'react';
import MockupPreviewPage from '../Mockups/MockupPreviewPage';

/** Generation type 5: blankets. */
const MockupsTowelPage = () => (
    <MockupPreviewPage title="Blanket preview" subtitle="Blanket mockups generated from customer photos." generationTypeId={5} />
);

export default MockupsTowelPage;
